import { connect } from 'react-redux';
import React from 'react';
import * as valid from 'utils/validate';
import { KBFormError, KBButton, KBInput, KBASNumberInput } from 'components';
import * as selectors from 'app/selectors';
import { bindActionCreators } from 'redux';
import { successState } from 'app/actions';
import { api, apiUtils } from 'app/services';
import _ from 'lodash';
import { reduxForm } from 'redux-form';
import { withReduxFormFieldProps } from 'components/formAdapters/reduxFormAdapters';

var SpaceSettingInvoiceForm = class extends React.Component {constructor(props) {super(props);this.updateSpace = this.updateSpace.bind(this);}updateSpace(

  model) {
    const { updateCurrentSpace } = this.props;
    updateCurrentSpace(
    JSON.stringify({
      invoice_settings: model }),

    {
      key: 'invoice_settings' });


  }render()
  {
    const {
      fields: { //invoice_due_offset,
        deposit_pay_offset },
      error,
      submitting,
      handleSubmit } =
    this.props;

    return (
      <form onSubmit={handleSubmit(this.updateSpace)}>
        <KBFormError error={this.props.error} />
        <div className="kb-form-container" style={{ padding: 0 }}>
          <div className="kb-row">
            <div className="f-left">
              <div>
                合同签订前&nbsp;&nbsp;(&nbsp;
                <span className="color-link">{deposit_pay_offset.value}</span>
                &nbsp;)&nbsp;&nbsp;天押金到期
              </div>
              <p className="color-nine d-iblock">
                示例：如果设置为5，意味着会在合同开始日之前5天催付押金
              </p>
            </div>
            <KBASNumberInput
            field={deposit_pay_offset}
            className="f-right"
            type="number"
            maxValue="31" />

          </div>
          {/* <div className="kb-row">
             <div className="f-left">
               <div>
                 缴租日前&nbsp;&nbsp;(&nbsp;
                 <span className="color-link">{invoice_due_offset.value}</span>
                 &nbsp;)&nbsp;&nbsp;天生成账单
               </div>
               <p className="color-nine d-iblock">
                 示例：收款日是31日，设置值为15，则会在16日生成账单
               </p>
             </div>
             <KBASNumberInput
               field={invoice_due_offset}
               className="f-right"
               type="number"
               maxValue="31"
             />
            </div> */}
          <div className="kb-row m-top">
            <KBButton
            className="certain-btn"
            type="submit"
            submitting={submitting}>

              确定
            </KBButton>
          </div>
        </div>
      </form>);

  }};


function mapStateToProps(state, props) {
  // const loc_id = _.get(props, 'locationId')
  // const locationSetting = selectors.getLocationSetting(state, loc_id) || {}
  const { setting: { invoice_settings = {} } = {} } = props;
  return {
    initialValues: {
      deposit_pay_offset: invoice_settings.deposit_pay_offset || 0 } };

}

function mapDispatchToProps(dispatch) {
  return {
    successAction: bindActionCreators(successState, dispatch) };

}

const formConfig = {
  form: 'SpaceSettingInvoiceForm',
  touchOnBlur: false };


const LEGACY_FORM_FIELDS = [
  "deposit_pay_offset"
];


export default connect(mapStateToProps, mapDispatchToProps)(reduxForm(formConfig)(withReduxFormFieldProps('SpaceSettingInvoiceForm', LEGACY_FORM_FIELDS)(SpaceSettingInvoiceForm)));
